import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import DashboardNavMenu from './NavMenu';

export default Object.assign(props => (
    <Grid fluid>
        <Row>
            <React.Fragment>
                <Col sm={2}>
                    <DashboardNavMenu />
                </Col>
                <Col sm={10}>
                    {props.children}
                </Col>
            </React.Fragment>
        </Row>
    </Grid>
), { DisplayName: "Layout" });



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layout.js